import { render, staticRenderFns } from "./DetailsAddons.vue?vue&type=template&id=27616190&scoped=true&"
import script from "./DetailsAddons.vue?vue&type=script&lang=js&"
export * from "./DetailsAddons.vue?vue&type=script&lang=js&"
import style0 from "./DetailsAddons.vue?vue&type=style&index=0&id=27616190&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27616190",
  null
  
)

export default component.exports